import {
  EditContextProvider,
  SaveButton,
  SimpleForm,
  Title,
  useEditController,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Tooltip from "@mui/material/Tooltip";
import { useParams } from "react-router-dom";
import { AppDeleteButton } from "../../components/AppDeleteButton";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { roleLabel } from "../../util/roleLabel";
import { UserRoleFormFields } from "./UserRoleFormFields";
import {
  isReservedRole,
  roleDeleteBlockReason,
  useRoleUserCount,
} from "./userRoleMeta";

export const UserRolesEdit = (props: any) => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "user-roles/crud",
    mutationMode: "pessimistic",
    id,
  });
  const record = controller?.record;
  const { count } = useRoleUserCount(record?.id);
  const blockReason = roleDeleteBlockReason(record?.name, count);

  return (
    <EditContextProvider value={controller}>
      <Title title="Regras de Usuário" />
      {/* toolbar={false}: Salvar/Remover no topo, junto do Ver */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Regras de Usuário"
          firstPath="/#/user-roles/crud"
          secondTitle="Editando"
          thirdTitle={record ? roleLabel(record.name) : undefined}
          actionType="show"
          actions={
            <>
              {/* Remover bloqueado para regra em uso ou usada pelo sistema */}
              <Tooltip title={blockReason || ""}>
                <span>
                  <AppDeleteButton label="Remover" disabled={Boolean(blockReason)} />
                </span>
              </Tooltip>
              <SaveButton label="Salvar" />
            </>
          }
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Regra de Usuário" />
          <CardContent>
            <UserRoleFormFields
              isEdit
              nameLocked={isReservedRole(record?.name)}
              userCount={count}
            />
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
